var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":100+'%',"fill":_vm.color,"viewBox":"0 0 340.847 340.847"}},[_c('ellipse',{attrs:{"id":"Ellipse_467","data-name":"Ellipse 467","cx":"143.689","cy":"143.689","rx":"143.689","ry":"143.689","transform":"matrix(0.978, -0.208, 0.208, 0.978, 0, 59.749)","fill":"#a7b1c6","opacity":"0.18"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }